export default "__VITE_ASSET__68711d1a__"